import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
const faqs = [{
  q: '¿Sirve para cualquier raza?',
  a: 'Sí, la biología del sistema inmune es la misma para un Chihuahua que para un Gran Danés.'
}, {
  q: '¿Debo dejar de darle sus medicinas?',
  a: 'Nunca suspendas medicación sin consultar a tu veterinario, pero nuestra guía está diseñada para ser compatible y eventualmente reducir la dependencia.'
}, {
  q: '¿Es difícil de preparar?',
  a: 'No, usamos ingredientes que ya tienes en casa o que encuentras en cualquier supermercado.'
}, {
  q: '¿En cuánto tiempo veré resultados?',
  a: 'Los cambios en la temperatura de la piel se notan en 24-48 horas; la sanación profunda toma 14 días.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-38">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <div className="text-center mb-16" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl border border-cream-200 overflow-hidden" data-id="element-43">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-44">
                <span className="text-lg font-bold text-charcoal pr-8" data-id="element-45">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 45 : 0
            }} transition={{
              duration: 0.2
            }} className="text-rust shrink-0" data-id="element-46">
                  <Plus size={24} data-id="element-47" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-48">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-49">
                    <div className="px-6 pb-6 text-charcoal-500" data-id="element-50">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}